import { render, staticRenderFns } from "./ProductDetailsLoyalty.vue?vue&type=template&id=1b452aae&"
import script from "./ProductDetailsLoyalty.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsLoyalty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports